// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Academy__LessonAccordionController from "./academy/lesson_accordion_controller"
application.register("academy--lesson-accordion", Academy__LessonAccordionController)

import Academy__NavController from "./academy/nav_controller"
application.register("academy--nav", Academy__NavController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AttachmentTrackerController from "./attachment_tracker_controller"
application.register("attachment-tracker", AttachmentTrackerController)

import Admin__NavController from "./admin/nav_controller"
application.register("admin--nav", Admin__NavController)

import CookiesBarController from "./cookies_bar_controller"
application.register("cookies-bar", CookiesBarController)

import CourseSortController from "./course_sort_controller"
application.register("course-sort", CourseSortController)

import BreadCalculatorController from "./bread_calculator_controller"
application.register("bread-calculator", BreadCalculatorController)

import SimpleBreadCalculatorController from "./simple_bread_calculator_controller"
application.register("simple-bread-calculator", SimpleBreadCalculatorController)

import StarterCalculatorController from "./starter_calculator_controller"
application.register("starter-calculator", StarterCalculatorController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import ReplyController from "./reply_controller"
application.register("reply", ReplyController)

import SmoothScrollController from "./smooth_scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import TiptapController from "./tiptap_controller"
application.register("tiptap", TiptapController)
